// export const host = "http://localhost:5000";
export const host = "https://chat-app-nodejs-uxeq.onrender.com";
export const loginRoute = `${host}/api/auth/login`;
export const registerRoute = `${host}/api/auth/register`;
export const logoutRoute = `${host}/api/auth/logout`;
export const allUsersRoute = `${host}/api/auth/allusers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const recieveMessageRoute = `${host}/api/messages/getmsg`;
export const setAvatarRoute = `${host}/api/auth/setavatar`;

// Email verification routes
export const sendVerificationCodeRoute = `${host}/api/auth/send-verification-code`;
export const verifyCodeRoute = `${host}/api/auth/verify-code`;
